import request from '@/utils/request'

/**
 * 获取地区列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getAreas(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/company/getAreas',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取店铺类型列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listShopTypes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopType.queryShopType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取注册协议
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getRegisterProtocolList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.listRegisterProtocol',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 提交店铺信息
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function replenishStoreAndShop(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.pcReplenishStoreAndShop',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}